import React, { useState, useRef } from 'react';
import { FaPlayCircle, FaPauseCircle } from 'react-icons/fa';
import { motion } from 'framer-motion';
import './AudioPlayer.css';

const AudioPlayer = ({ onPlayPause }) => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlayPause = () => {
    if (!audioRef.current) return;

    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play()
        .catch(err => console.error('Audio play error:', err));
    }

    setIsPlaying(prev => {
      onPlayPause(!prev);
      return !prev;
    });
  };

  return (
    <>
      <audio
        ref={audioRef}
        loop
        preload="auto"
        onEnded={() => setIsPlaying(false)}
      >
        <source src="/music.mp3" type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>

      <motion.button
        className={`play-pause-button ${isPlaying ? 'playing' : ''}`}
        onClick={togglePlayPause}
        aria-label={isPlaying ? 'Pause Music' : 'Play Music'}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
      >
        {isPlaying ? <FaPauseCircle size={22} /> : <FaPlayCircle size={22} />}
      </motion.button>
    </>
  );
};

export default AudioPlayer;
